import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        container: '[js-site-header="container"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initHeader()
    }

    function initHeader() {
        let scrollDirectionDown = true

        window.addEventListener('scroll', function() {
            /**
             * Hide/Show header on scroll
             * If user scrolls down header will be hidden or if user scrolls up header will be visible
             */
            scrollDirectionDown = this.oldScroll <= this.scrollY
            this.oldScroll = this.scrollY

            if ( scrollDirectionDown ) {
                // Scrolling down
                if(
                    window.scrollY > 100
                    &&
                    !$(nodeSelectors.container).hasClass('nav-is-active')
                )
                    hideHeader()
            } else {
                showHeader()
            }
            /**
             * Hide/Show header on scroll END
             */
        })
    }

    function showHeader() {
        document.querySelector(nodeSelectors.container).style.top = '0px'
    }

    function hideHeader() {
        document.querySelector(nodeSelectors.container).style.top = - document.querySelector(nodeSelectors.container).offsetHeight + 'px'
    }

    //Update time
    const timeEl = $('.update-time');
    if( timeEl.length ) {
        let formatter = new Intl.DateTimeFormat([], {
            timeZone: 'Europe/Belgrade',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        });

        function setTime(){ timeEl.html(formatter.format(new Date())); }
        setTime();
        setInterval(setTime, 1000);
    }

    return Object.freeze({
        init,
        nodeSelectors,
        showHeader,
        hideHeader
    })
}